<template>
  <el-dialog
    :title="title || '视频播放'"
    :visible.sync="dialogVisible"
    width="60%"
    append-to-body
    :destroy-on-close="true"
    @close="onClose">
    <video
      v-if="dialogVisible && videoUrl"
      ref="video"
      :src="videoUrl"
      controls
      autoplay
      style="width:100%;max-height:70vh;background:#000">
      您的浏览器不支持视频播放
    </video>
  </el-dialog>
</template>

<script>
export default {
  name: 'videoPlayer',
  data() {
    return {
      dialogVisible: false,
      videoUrl: '',
      title: ''
    }
  },
  methods: {
    // 打开播放器：path 为后端返回的相对路径（如 /video/xxx.mp4）或完整地址
    open(path, title) {
      if (!path) return
      this.videoUrl = path.indexOf('http') === 0 ? path : this.$store.state.configure.HOST + path
      this.title = title || '视频播放'
      this.dialogVisible = true
    },
    onClose() {
      if (this.$refs.video) {
        this.$refs.video.pause()
      }
      this.videoUrl = ''
    }
  }
}
</script>
